
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"2 min read","minutes":1.04,"time":62400.00000000001,"words":208}
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`An event on round number 11 on the round track (round number 12 in extended play) where players are able to purchase as many improvements from the builders’ market as their resources allow. This special round is marked by a quarried pile of rocks.`}</p>
    <div className="flavor-text">
      <p>{`The quarry symbol (pile of rocks) on the round track represents the sudden availability of cheap building materials or an influx of new skilled craftsmen that ignite a building boom.`}</p>
    </div>
    <p>{`Normal turns limit a player to one purchase from the market. During the Builders’ Holiday however, purchases are unlimited, provided the player has (or can acquire) the necessary wealth. This presents the player with a unique opportunity to acquire critical tiles to complete objectives or to excel in a courtship category. If a player purchases more than one improvement tile from the market, the remaining tiles are moved leftward, opening up blank spaces on the right side of the market row. These open spaces are filled with new tiles drawn from the tile bag and placed in prestige rating order, lowest to the left, highest to the right. If there is a tie in prestige rating, use the tiebreakers described in the `}<a parentName="p" {...{
        "href": "builders-market"
      }}>{`builders’ market Glossary entry`}</a>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {
  "title": "Builders’ Holiday"
}

